import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  enrollmentGroup: css`
    background-color: ${colors.platinum};
    padding: 24px 16px 32px 16px;
    border-radius: 12px;
    margin-bottom: 24px;
    position: relative;
    & .MuiAutocomplete-inputRoot {
      & .MuiAutocomplete-input {
        text-transform: capitalize;
      }
    }
  `,
  cardBorder: css`
    height: 1px;
    border-bottom: 1px solid ${colors.silver};
    z-index: 1;
    position: relative;
    top: 64px;
    margin: 0px 1px;
  `,
  inputWithToolTip: css`
    width: 90% !important;
  `,
  gradeOptions: css`
    width: 100% !important;
    padding: 0;
    margin-top: 24px;
    & .MuiInputLabel-root {
      font-family: 'Montserrat Regular';
      line-height: 1.45;
      letter-spacing: -0.4px;
      &.Mui-focused {
        color: ${colors.slate};
      }
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .MuiInputBase-input {
      font-family: 'Montserrat Regular' !important;
      font-size: 16px;
      line-height: 1.43;
      letter-spacing: -0.4px;
      color: ${colors.prussian};
    }
    .MuiInputBase-input {
      border-bottom-color: ${colors.prussian} !important;
    }
  `,
  inlined: css`
    display: inline-block;
  `,
  infoIcon: css`
    position: absolute;
    top: 185px;
    padding-left: 15px;
  `,
  tooltipButton: css`
    & .MuiIconButton-root {
      color: ${colors.prussian};
    }
    & .MuiIconButton-root:hover {
      background-color: rgba(97, 193, 108, 0.15);
    }
  `,
  formSectionHeadline: css`
    margin-bottom: 36px;
  `,
  secondaryName: css`
    font-size: ${pxToRem(13)};
    font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
    color: ${colors.slate};
    display: block;
  `,
  removeIcon: css`
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  `,
  ctaLink: css`
    color: ${colors.jungle};
    font-size: ${pxToRem(16)};
    display: block;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: ${colors.jungle};
    }
  `,
  footer: css`
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;

    & > div {
      margin-left: 10px;
    }
  `,
  label: css`
    display: block;
    padding-bottom: 8px;
    line-height: 16px;
  `,
  labelGrade: css`
    padding-top: 24px;
  `,
  textInput: css`
    font-size: ${pxToRem(16)} !important;
    color: ${colors.prussian};
    text-transform: capitalize;
    line-height: 24px;
    padding-bottom: 24px;
  `,
  autocomplete: css`
    .MuiFormLabel-root {
      font-family: 'Montserrat Regular';
      line-height: 1.45;
      letter-spacing: -0.4px;
      &.Mui-focused {
        color: ${colors.slate};
      }
    }
    .MuiInputBase-input {
      font-family: 'Montserrat Regular' !important;
      font-size: ${pxToRem(16)} !important;
      line-height: 1.43;
      letter-spacing: -0.4px;
      color: ${colors.prussian};
    }
    .MuiFormHelperText-root {
      span {
        font-family: 'Montserrat Regular';
        font-size: ${pxToRem(11)};
        color: ${colors.dragon};
      }
    }
  `,
  hasError: css`
    border: 1px solid ${colors.dragon};
  `,
  inputGradeError: css`
    .MuiInputBase-input {
      border-bottom: 1px solid ${colors.dragon};
    }
  `,
  inputSchoolError: css`
    .MuiInput-underline:before {
      border-bottom: 1px solid ${colors.dragon};
    }
  `,
};

export default styles;
